import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2461741a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-1" }
const _hoisted_3 = { class: "p-mx-1" }
const _hoisted_4 = { class: "p-mx-1" }
const _hoisted_5 = { class: "p-mx-1" }
const _hoisted_6 = { class: "p-mx-1" }
const _hoisted_7 = { class: "p-grid p-text-center p-m-0 style-grid" }
const _hoisted_8 = { class: "p-col" }
const _hoisted_9 = { class: "p-mx-2" }
const _hoisted_10 = { class: "p-mx-2" }
const _hoisted_11 = { class: "p-mx-2" }
const _hoisted_12 = { class: "p-mx-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_14 = { class: "p-buttonset" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              label: "Clear All",
              class: "p-button-danger",
              onClick: _ctx.clearAll
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              label: "Add Row",
              class: "p-button-success",
              onClick: _ctx.addNewRow
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-download",
              label: "Download Stock CSV",
              class: "p-button-warning",
              onClick: _ctx.downloadSample
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-upload",
              label: "Upload Stock CSV",
              class: "p-button-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFileUploader()))
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Button, {
              icon: "pi pi-check",
              label: "Save Stock",
              class: "p-button-success",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveFileData()))
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("b", _hoisted_9, " TOTAL ITEMS : " + _toDisplayString(_ctx.totalItems), 1),
          _createElementVNode("b", _hoisted_10, " VALID ITEMS : " + _toDisplayString(_ctx.totalValid), 1),
          _createElementVNode("b", _hoisted_11, " INVALID ITEMS : " + _toDisplayString(_ctx.totalInValid), 1),
          _createElementVNode("b", _hoisted_12, " STOCK WORTH AMT : " + _toDisplayString(_ctx.stockWorth), 1)
        ])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.excelFileContent,
        responsiveLayout: "scroll",
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
      }, {
        empty: _withCtx(() => [
          _hoisted_13
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, null, {
            body: _withCtx((slotProps) => [
              _createElementVNode("i", {
                class: _normalizeClass([this.validateStock.includes(_ctx.excelFileContent.indexOf(slotProps.data)) ? 'row-invalid' : 'row-valid', "pi pi-check-circle p-p-2"])
              }, null, 2)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Product Name" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.productName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.productName) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Generic Name" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.genericName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.genericName) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Barcode" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.barcode,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.barcode) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Product Type" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                id: "type",
                modelValue: slotProps.data.productType,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.productType) = $event),
                options: _ctx.productType,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Brand Name" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                id: "type",
                modelValue: slotProps.data.brandName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.brandName) = $event),
                options: _ctx.brand,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Brand Sector" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                id: "type",
                modelValue: slotProps.data.brandSector,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.brandSector) = $event),
                options: _ctx.brandSector,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Category" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                id: "type",
                modelValue: slotProps.data.category,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.category) = $event),
                options: _ctx.category,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Side Effects" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.sideEffects,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sideEffects) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Strip Size" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                useGrouping: false,
                modelValue: slotProps.data.stripSize,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.stripSize) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Pack Size" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                useGrouping: false,
                modelValue: slotProps.data.packSize,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.packSize) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Unit Quantity" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                useGrouping: false,
                modelValue: slotProps.data.quantity,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.quantity) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Expiry Date (DD-MM-YYYY)" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Calendar, {
                modelValue: slotProps.data.expiryDate,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.expiryDate) = $event),
                selectionMode: "single",
                dateFormat: "dd-mm-yy",
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Pack Purchase Price" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                modelValue: slotProps.data.packPurchasePrice,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.packPurchasePrice) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "ITEM WORTH AMT" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                value: _ctx.getPackWorth(slotProps.data),
                class: "p-p-1",
                disabled: true
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "MRP (TAXES INCLUSIVE)" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                modelValue: slotProps.data.mRP,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.mRP) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Pack Price (MRP - TAXES)" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                modelValue: slotProps.data.packSellingPrice,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.packSellingPrice) = $event),
                value: _ctx.getPackSellingPrice(slotProps.data),
                class: "p-p-1",
                disabled: true
              }, null, 8, ["modelValue", "onUpdate:modelValue", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Batch No" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.batchNo,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.batchNo) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          (_ctx.taxName1 != '')
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                header: _ctx.taxName1+' %'
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputNumber, {
                    mode: "decimal",
                    maxFractionDigits: 2,
                    minFractionDigits: 2,
                    modelValue: slotProps.data.tax_1,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.tax_1) = $event),
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          (_ctx.taxName2 != '')
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 1,
                header: _ctx.taxName2+' %'
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputNumber, {
                    mode: "decimal",
                    maxFractionDigits: 2,
                    minFractionDigits: 2,
                    modelValue: slotProps.data.tax_2,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.tax_2) = $event),
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          (_ctx.taxName3 != '')
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 2,
                header: _ctx.taxName3+' %'
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputNumber, {
                    mode: "decimal",
                    maxFractionDigits: 2,
                    minFractionDigits: 2,
                    modelValue: slotProps.data.tax_3,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.tax_3) = $event),
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, { header: "Discount Percentage" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                modelValue: slotProps.data.discountPercentage,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.discountPercentage) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Description" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.description,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.description) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Minimum Stock" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                useGrouping: false,
                modelValue: slotProps.data.minimumStock,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.minimumStock) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Store Locations" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.storeLocations,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.storeLocations) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-rounded p-button-danger",
                  onClick: ($event: any) => (_ctx.clearListItem(slotProps.data))
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_FileUploader, {
        uploaderDetail: {
          status: _ctx.uploaderStatus,
          dialogTitle: 'Upload Stock CSV file:',
          imageType: '.csv',
        },
        onUpdateUploaderStatus: _ctx.updateUploaderStatus
      }, null, 8, ["uploaderDetail", "onUpdateUploaderStatus"])
    ])
  ]))
}